import "@arco-design/web-react/es/_util/react-19-adapter";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "@arco-design/web-react";
import zhCN from "@arco-design/web-react/es/locale/zh-CN";
import "@arco-design/web-react/dist/css/arco.css";
import "@fontsource-variable/inter";
import "@fontsource-variable/inter-tight";
import "./styles.css";
import "./styles/themes.css";
import { App } from "./App";
import { initializeTheme, ThemeProvider } from "./theme";
initializeTheme();
const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, staleTime: 10000 } },
});
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <ConfigProvider
        locale={zhCN}
        componentConfig={{
          Button: { size: "default" },
          Input: { size: "large" },
        }}
      >
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ConfigProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
